import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Overview, About, HowItWorks, Highlights } from "@/components/site/AboutHow";
import { Categories, WhyCustomers } from "@/components/site/CategoriesWhy";
import { FeaturedDeals } from "@/components/site/FeaturedDeals";
import { BusinessOpportunity, Franchise } from "@/components/site/BusinessFranchise";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-[#FFFFFF]">
      <Header />
      <main>
        <Hero />
        <Highlights />
        <Overview />
        <About />
        <HowItWorks />
        <Categories />
        <FeaturedDeals />
        <WhyCustomers />
        <BusinessOpportunity />
        <Franchise />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
